import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

import { ProfileCard } from '@/components/ProfileCard'
import { withTitle } from '@/utils/withTitle.ts'

export const Route = createFileRoute('/_app/profile')({
  component: ProfilePage,
  head: withTitle('My Profile'),
})

function ProfilePage() {
  return (
    <Stack>
      <ProfileCard />
    </Stack>
  )
}
